export function decodeBase64ToNumber(base64: string) {
    return Number(window.atob(base64.toString()))
}

export function encodeBase64(value: string) {
    return window.btoa(value.toString())
}
